<h2 mat-dialog-title>INTERNAL NOTE</h2>
<mat-dialog-content>
  <p class="internal-note-hint">Internal only — never visible to patients.</p>
  <mat-form-field appearance="fill" class="internal-note-field">
    <mat-label>Note</mat-label>
    <textarea matInput rows="8" [(ngModel)]="note"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">CANCEL</button>
  <button mat-raised-button color="primary" type="button" (click)="save()">SAVE</button>
</mat-dialog-actions>
